import { gql } from '__generated__';

export default gql(`
  query GetAppsForProject($project_id: ID!) {
    project(id: $project_id) {
      id
      organisation_name
      app_authorizations {
        app {
          id
          name
          created_at
        }
        permissions
      }
    }
  }
`);
